jQuery(document).ready(function($) {
  /* Product about desc toggle */
  $('.about-product-wrapper .readmore-description .toggle-readmore').on('click', function(e) {
    $(this).toggleClass('active');
    $(this).parent('.readmore-description').toggleClass('full-view');
  });

  /* Product Piece Label */
  var checkedVariant = $('.variant-picker__option-values input:checked').val();
  
  if ( checkedVariant ) {
    if (checkedVariant.indexOf('floor panel') >= 0) {
      $('.product__price--piece').addClass('product__price--piece--panel');
    } else {
      $('.product__price--piece').removeClass('product__price--piece--panel');
    }
  }

  $('.variant-picker__option .block-swatch').on('click', function() {
    var $this = $(this),
        variantHandle = $this.data('variant-handle');

    if (!variantHandle) return;
    
    if ($('.stair-height').length > 0 && $this.hasClass('stair-swatch')) {
      if (variantHandle.indexOf('individual') >= 0) {
        document.querySelector('.stair-height').style.display = 'block';
        document.querySelector('.stair-height-input').setAttribute('required', '');
        document.querySelector('.stair-height-input').setAttribute('name', 'properties[Stair Height]');
        document.querySelector('.stair-height-input-hidden').setAttribute('name', 'properties[Stair Height]');
        setTimeout(function() {
          $('.product-info__quantity-selector .shopify-product-form .button').prop('disabled', true);
        }, 200);
      } else {
        document.querySelector('.stair-height').style.display = 'none';
        document.querySelector('.stair-height-input').removeAttribute('required');
        document.querySelector('.stair-height-input').setAttribute('name', 'none');
        document.querySelector('.stair-height-input-hidden').setAttribute('name', 'none');
        document.querySelector('.stair-height-input-hidden').removeAttribute('value');
        $('.stair-height-input').val('');
        $('.product-info__quantity-selector .shopify-product-form .button').prop('disabled', false);
      }
    }

    if (variantHandle.indexOf('floor-panel') >= 0) {
      $('.product__price--piece').addClass('product__price--piece--panel');
    } else {
      $('.product__price--piece').removeClass('product__price--piece--panel');
    }

    setTimeout(() => {
      var variantPrice = $('.product-info__price price-list sale-price .money').text();
      
      // $('.product-info__quantity-selector .shopify-product-form .button div').append('<span class="money">'+ variantPrice +'</span>');
    }, 200);
  });

  /* Custom Choose finish */
  $('.choose-finish .variant-picker__option .block-swatch').on('click', function() {
    var radioFinishVal = $(this).prev('input').val();
    $('.choose-finish-hidden').val(radioFinishVal).trigger('change');
  });

  /* Stair Height */
  $(document).on('change', '.stair-height-input', function () {
    var $this = $(this),
        value = $this.val();

    if ( value < 4 ) $this.val(4);
    if ( value > 8 ) $this.val(8);
    
    if ( value >= 4 && value <= 8 ) {
      var integerVal = value.split('.')[0];
      var decimalVal = value.split('.')[1];

      if ( decimalVal < 4 ) $this.val(parseInt(integerVal));
      if ( decimalVal >= 4 && decimalVal <= 7 ) $this.val(parseFloat(integerVal + '.5'));
      if ( decimalVal > 7 ) $this.val(parseInt(integerVal) + 1);
    }

    $('.stair-height-input-hidden').val($this.val()).trigger('change');
    $('.product-info__quantity-selector .shopify-product-form .button').prop('disabled', false);
  });

  if ( $('input[name="properties[Stair Height]"]').length > 0 ) {
    if ( $('.stair-height-input-hidden').val().length === 0 ) {
      $('.product-info__quantity-selector .shopify-product-form .button').prop('disabled', true);
    }
  }

  /* Surface popup */
  $(document).on('click', '.surface-popup__overlay', function () {
    $('.surface-popup').removeClass('surface-popup--active');
    $('body').removeClass('lock-scroll');
  });

  $(document).on('click', '.surface-popup__close', function () {
    $('.surface-popup').removeClass('surface-popup--active');
    $('body').removeClass('lock-scroll');
  });

  $(document).on('click', '.calculate-surface', function () {
    $('.surface-popup').addClass('surface-popup--active');
    $('body').addClass('lock-scroll');
    var variantId = $('.product-single__variants').val();
    if ($('.surface-popup').hasClass('surface-popup--wallpaper') || $('.surface-popup').hasClass('surface-popup--floor')) {
      $('.surface-variant__selector option:nth-child(2)').prop('selected', true);
    }
    else {
      $('.surface-variant__selector option[data-variant="' + variantId + '"]').prop('selected', true);
    }

    if ($('.surface-popup').hasClass('surface-popup--sticker')) {
      if ($('.surface-variant__selector').val().indexOf('floor panel') >= 0) {
        $('.surface-result__row--tiles .surface-result__label').text("Total panels you'll need to cover your area inc. wastage");
        $('.surface-result__row--qty .surface-result__label').text("Total panels you'll get");
        $('.surface-view__img').attr('src', 'https://cdn.shopify.com/s/files/1/0049/0301/0402/t/26/assets/surface-calculator-floor.png');
        $('.surface-view__content').text("Divide the surface you want to cover into individual rectangles to calculate how many floor panels you'll need.");
        $('.surface-result__row--pack').css('display', 'none');
      }
      else {
        $('.surface-result__row--tiles .surface-result__label').text("Total tiles you'll need to cover inc. wastage");
        $('.surface-result__row--qty .surface-result__label').text("Total stickers you'll get");
        $('.surface-view__img').attr('src', 'https://cdn.shopify.com/s/files/1/0049/0301/0402/t/26/assets/surface-calculator-sticker-new.png?v=112799501015700841601668611515');
        $('.surface-view__content').text("Divide the surface you want to cover into individual rectangles to calculate how many tiles you have in each section.");
        $('.surface-result__row--pack').css('display', 'flex');
      }
    }
    if ($('.surface-popup').hasClass('surface-popup--floor')) {
      $('.surface-result__row--tiles .surface-result__label').text("Total panels you'll need to cover your area inc. wastage");
      $('.surface-result__row--qty .surface-result__label').text("Total panels you'll get");
      $('.surface-view__img').attr('src', 'https://cdn.shopify.com/s/files/1/0049/0301/0402/t/26/assets/surface-calculator-floor.png');
      $('.surface-view__content').text("Divide the surface you want to cover into individual rectangles to calculate how many floor panels you'll need.");
      $('.surface-result__row--pack').css('display', 'none');
    }
  });

  $(document).on('click', '.surface-row__add', function () {
    if ($('.surface-action__row').length < 3) {
      if ($('.surface-unit__item--in').hasClass('surface-unit__item--active')) {
        var html = '<div class="surface-action__row">' +
                    '<div class="surface-row__heading">' +
                      '<span class="surface-row__num">' + ($('.surface-action__row').length + 1) + '</span>' +
                      '<span class="surface-row__title">Surface to cover</span>' +
                      '<a href="javascript:void(0);" class="surface-row__remove" title="Remove"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M5.625 2.875H5.5C5.56875 2.875 5.625 2.81875 5.625 2.75V2.875H10.375V2.75C10.375 2.81875 10.4312 2.875 10.5 2.875H10.375V4H11.5V2.75C11.5 2.19844 11.0516 1.75 10.5 1.75H5.5C4.94844 1.75 4.5 2.19844 4.5 2.75V4H5.625V2.875ZM13.5 4H2.5C2.22344 4 2 4.22344 2 4.5V5C2 5.06875 2.05625 5.125 2.125 5.125H3.06875L3.45469 13.2969C3.47969 13.8297 3.92031 14.25 4.45312 14.25H11.5469C12.0813 14.25 12.5203 13.8313 12.5453 13.2969L12.9312 5.125H13.875C13.9438 5.125 14 5.06875 14 5V4.5C14 4.22344 13.7766 4 13.5 4ZM11.4266 13.125H4.57344L4.19531 5.125H11.8047L11.4266 13.125Z" fill="#111111"/></svg></a>' +
                    '</div>' +
                    '<div class="surface-row__input surface-row__input--length">' +
                      '<span class="surface-input__label">Length</span>' +
                      '<div class="surface-input__box">' +
                        '<div class="surface-input__ft">' +
                          '<span>ft</span>' +
                          '<input type="number" step="0.01" value="0">' +
                        '</div>' +
                        '<div class="surface-input__in">' +
                          '<span>in</span>' +
                          '<input type="number" step="0.01" value="0">' +
                        '</div>' +
                      '</div>' +
                    '</div>' +
                    '<div class="surface-row__input surface-row__input--width">' +
                      '<span class="surface-input__label">Width</span>' +
                      '<div class="surface-input__box">' +
                        '<div class="surface-input__ft">' +
                          '<span>ft</span>' +
                          '<input type="number" step="0.01" value="0">' +
                        '</div>' +
                        '<div class="surface-input__in">' +
                          '<span>in</span>' +
                          '<input type="number" step="0.01" value="0">' +
                        '</div>' +
                      '</div>' +
                    '</div>' +
                    '<hr class="hr--small">' +
                  '</div>';
        $(html).insertBefore('.surface-row__add');
      }
      else {
        var html = '<div class="surface-action__row">' +
                    '<div class="surface-row__heading">' +
                      '<span class="surface-row__num">' + ($('.surface-action__row').length + 1) + '</span>' +
                      '<span class="surface-row__title">Surface to cover</span>' +
                      '<a href="javascript:void(0);" class="surface-row__remove" title="Remove"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M5.625 2.875H5.5C5.56875 2.875 5.625 2.81875 5.625 2.75V2.875H10.375V2.75C10.375 2.81875 10.4312 2.875 10.5 2.875H10.375V4H11.5V2.75C11.5 2.19844 11.0516 1.75 10.5 1.75H5.5C4.94844 1.75 4.5 2.19844 4.5 2.75V4H5.625V2.875ZM13.5 4H2.5C2.22344 4 2 4.22344 2 4.5V5C2 5.06875 2.05625 5.125 2.125 5.125H3.06875L3.45469 13.2969C3.47969 13.8297 3.92031 14.25 4.45312 14.25H11.5469C12.0813 14.25 12.5203 13.8313 12.5453 13.2969L12.9312 5.125H13.875C13.9438 5.125 14 5.06875 14 5V4.5C14 4.22344 13.7766 4 13.5 4ZM11.4266 13.125H4.57344L4.19531 5.125H11.8047L11.4266 13.125Z" fill="#111111"/></svg></a>' +
                    '</div>' +
                    '<div class="surface-row__input surface-row__input--length">' +
                      '<span class="surface-input__label">Length</span>' +
                      '<div class="surface-input__box">' +
                        '<div class="surface-input__ft">' +
                          '<span>m</span>' +
                          '<input type="number" step="0.01" value="0">' +
                        '</div>' +
                        '<div class="surface-input__in">' +
                          '<span>cm</span>' +
                          '<input type="number" step="0.01" value="0">' +
                        '</div>' +
                      '</div>' +
                    '</div>' +
                    '<div class="surface-row__input surface-row__input--width">' +
                      '<span class="surface-input__label">Width</span>' +
                      '<div class="surface-input__box">' +
                        '<div class="surface-input__ft">' +
                          '<span>m</span>' +
                          '<input type="number" step="0.01" value="0">' +
                        '</div>' +
                        '<div class="surface-input__in">' +
                          '<span>cm</span>' +
                          '<input type="number" step="0.01" value="0">' +
                        '</div>' +
                      '</div>' +
                    '</div>' +
                    '<hr class="hr--small">' +
                  '</div>';
        $(html).insertBefore('.surface-row__add');
      }
    }
    else {
      $('.surface-row__add').addClass('surface-row__add--disabled');
    }
  });

  function calcPricing() {
    var areaTotal = 0, areaTotal_cm = 0;
    var unitTile = 0, unitTile_cm = 0;
    var variantTitle = $('.surface-variant__selector').val();
    var sizeLength = 0;
    var sizeWidth = 0;
    var wasteFactor = $('.surface-waste__selector').val();
    var unitPrice = $('.surface-variant__selector option:selected').attr('data-price');
    if (variantTitle.indexOf('pcs') >= 0) {
      sizeLength = parseInt(variantTitle.split('(')[0].split('x')[0].split('pcs ')[1].replace('"', '').replace(' ', ''));
      sizeWidth = parseInt(variantTitle.split('(')[0].split('x')[1].replace('"', '').replace(' ', ''));
    }
    else if (variantTitle.indexOf('floor panel') >= 0) {
      sizeLength = parseInt(variantTitle.split('(')[0].split('x')[0].split('panel ')[1].replace('"', '').replace(' ', ''));
      sizeWidth = parseInt(variantTitle.split('(')[0].split('x')[1].replace('"', '').replace(' ', ''));
    }
    else if (variantTitle.indexOf('samples') >= 0) {
      sizeLength = parseInt(variantTitle.split('(')[0].split('x')[0].split('samples ')[1].replace('"', '').replace(' ', ''));
      sizeWidth = parseInt(variantTitle.split('(')[0].split('x')[1].replace('"', '').replace(' ', ''));
    }
    else if (variantTitle.indexOf('sample') >= 0) {
      sizeLength = parseInt(variantTitle.split('(')[0].split('x')[0].split('sample ')[1].replace('"', '').replace(' ', ''));
      sizeWidth = parseInt(variantTitle.split('(')[0].split('x')[1].replace('"', '').replace(' ', ''));
    }
    else if (variantTitle.indexOf('panel') >= 0) {
      sizeLength = parseInt(variantTitle.split('(')[0].split('x')[0].split('panel ')[1].replace('"', '').replace(' ', ''));
      sizeWidth = parseInt(variantTitle.split('(')[0].split('x')[1].replace('"', '').replace(' ', ''));
    }
    unitTile = sizeLength * sizeWidth;
    unitTile_cm = (sizeLength * 2.54) * (sizeWidth * 2.54);
    $('.surface-action__row').each(function () {
      if ($('.surface-unit__item--in').hasClass('surface-unit__item--active')) {
        var length_ft = parseFloat($(this).find('.surface-row__input--length .surface-input__ft input').val());
        var length_in = parseFloat($(this).find('.surface-row__input--length .surface-input__in input').val());
        var width_ft = parseFloat($(this).find('.surface-row__input--width .surface-input__ft input').val());
        var width_in = parseFloat($(this).find('.surface-row__input--width .surface-input__in input').val());

        var length_m = (length_ft / 3.281).toFixed(2);
        var length_cm = (length_in * 2.54).toFixed(2);
        var width_m = (width_ft / 3.281).toFixed(2);
        var width_cm = (width_in * 2.54).toFixed(2);
      }
      else {
        var length_m = parseFloat($(this).find('.surface-row__input--length .surface-input__ft input').val());
        var length_cm = parseFloat($(this).find('.surface-row__input--length .surface-input__in input').val());
        var width_m = parseFloat($(this).find('.surface-row__input--width .surface-input__ft input').val());
        var width_cm = parseFloat($(this).find('.surface-row__input--width .surface-input__in input').val());
  
        var length_ft = (length_m * 3.281).toFixed(2);
        var length_in = (length_cm / 2.54).toFixed(2);
        var width_ft = (width_m * 3.281).toFixed(2);
        var width_in = (width_cm / 2.54).toFixed(2);
      }

      var lengthInches = parseFloat(length_ft) * 12 + parseFloat(length_in);
      var widthInches = parseFloat(width_ft) * 12 + parseFloat(width_in);
      areaTotal += lengthInches * widthInches;

      var lengthCm = parseFloat(length_m) * 100 + parseFloat(length_cm);
      var widthCm = parseFloat(width_m) * 100 + parseFloat(width_cm);
      areaTotal_cm += lengthCm * widthCm; 
    });
    if (areaTotal > 0) {
      if ($('.surface-unit__item--in').hasClass('surface-unit__item--active')) {
        areaTotal = Math.ceil(areaTotal);
        var areaInches = areaTotal % 144;
        var areaFeet = (areaTotal - areaInches) / 144;
        var areaTiles = Math.ceil(Math.ceil(parseFloat(areaTotal_cm) / parseFloat(unitTile_cm)) * parseFloat(wasteFactor));
        var resultPacks = Math.ceil(areaTiles / 8);
        var resultTiles = 8 * resultPacks;
        if ($('.surface-popup__result').hasClass('surface-popup__result--wallpaper') || $('.surface-variant__selector').val().indexOf('panel') >= 0) {
          resultPacks = areaTiles;
          resultTiles = areaTiles;
        }
        var totalPrice = unitPrice * resultPacks;
        $('.surface-result__area--ft').text(areaFeet);
        $('.surface-result__area--in').text(areaInches);
        $('.surface-result__tiles--nowaste').text(areaTiles);
        $('.surface-result__packs').text(resultPacks);
        $('.surface-result__tiles--waste').text(resultTiles);
        if (window.DoublyGlobalCurrency) {
          $('.surface-result__price').html(window.DoublyGlobalCurrency.formatMoney(totalPrice, window.DoublyGlobalCurrency.moneyFormats[window.DoublyGlobalCurrency.currentCurrency].money_with_currency_format));
        }
        else {
          $('.surface-result__price').html(window.Shopify.formatMoney(totalPrice, window.currency_format));
        }
        $('.surface-result__apply').removeClass('surface-result__apply--disabled');
      }
      else {
        areaTotal_cm = Math.ceil(areaTotal_cm);
        var areaMeters = parseFloat(areaTotal_cm) / 10000.0;
        var areaTiles = Math.ceil(Math.ceil(parseFloat(areaTotal_cm) / parseFloat(unitTile_cm)) * parseFloat(wasteFactor));
        var resultPacks = Math.ceil(areaTiles / 8);
        var resultTiles = 8 * resultPacks;
        if ($('.surface-popup__result').hasClass('surface-popup__result--wallpaper') || $('.surface-variant__selector').val().indexOf('panel') >= 0) {
          resultPacks = areaTiles;
          resultTiles = areaTiles;
        }
        var totalPrice = unitPrice * resultPacks;
        $('.surface-result__area--ft').text(areaMeters.toFixed(2));
        $('.surface-result__tiles--nowaste').text(areaTiles);
        $('.surface-result__packs').text(resultPacks);
        $('.surface-result__tiles--waste').text(resultTiles);
        if (window.DoublyGlobalCurrency) {
          $('.surface-result__price').html(window.DoublyGlobalCurrency.formatMoney(totalPrice, window.DoublyGlobalCurrency.moneyFormats[window.DoublyGlobalCurrency.currentCurrency].money_with_currency_format));
        }
        else {
          $('.surface-result__price').html(window.Shopify.formatMoney(totalPrice, window.currency_format));
        }
        $('.surface-result__apply').removeClass('surface-result__apply--disabled');
      }
    }
    else {
      $('.surface-result__area--ft').text('0');
      $('.surface-result__area--in').text('0');
      $('.surface-result__tiles--nowaste').text('0');
      $('.surface-result__packs').text('0');
      $('.surface-result__tiles--waste').text('0');
      if (window.DoublyGlobalCurrency) {
        $('.surface-result__price').html(window.DoublyGlobalCurrency.formatMoney(0, window.DoublyGlobalCurrency.moneyFormats[window.DoublyGlobalCurrency.currentCurrency].money_with_currency_format));
      }
      else {
        $('.surface-result__price').html(window.Shopify.formatMoney(0, window.currency_format));
      }
      $('.surface-result__apply').addClass('surface-result__apply--disabled');
    }
  }

  $(document).on('click', '.surface-row__remove', function () {
    $(this).parents('.surface-action__row').remove();
    if ($('.surface-action__row').length > 1) {
      $('.surface-action__row:nth-child(2) .surface-row__num').text('2');
    }
    $('.surface-row__add').removeClass('surface-row__add--disabled');
  });

  $(document).on('change', '.surface-input__ft input', function () {
    calcPricing();
  });

  $(document).on('change', '.surface-input__in input', function () {
    calcPricing();
  });

  $(document).on('change', '.surface-waste__selector', function () {
    calcPricing();
  });

  $(document).on('change', '.surface-variant__selector', function () {
    calcPricing();
    if ($('.surface-popup').hasClass('surface-popup--sticker')) {
      if ($(this).val().indexOf('floor panel') >= 0) {
        $('.surface-result__row--tiles .surface-result__label').text("Total panels you'll need to cover your area inc. wastage");
        $('.surface-result__row--qty .surface-result__label').text("Total panels you'll get");
        $('.surface-view__img').attr('src', 'https://cdn.shopify.com/s/files/1/0049/0301/0402/t/26/assets/surface-calculator-floor.png');
        $('.surface-view__content').text("Divide the surface you want to cover into individual rectangles to calculate how many floor panels you'll need.");
        $('.surface-result__row--pack').css('display', 'none');
      }
      else {
        $('.surface-result__row--tiles .surface-result__label').text("Total tiles you'll need to cover inc. wastage");
        $('.surface-result__row--qty .surface-result__label').text("Total stickers you'll get");
        $('.surface-view__img').attr('src', 'https://cdn.shopify.com/s/files/1/0049/0301/0402/t/26/assets/surface-calculator-sticker-new.png?v=112799501015700841601668611515');
        $('.surface-view__content').text("Divide the surface you want to cover into individual rectangles to calculate how many tiles you have in each section.");
        $('.surface-result__row--pack').css('display', 'flex');
      }
    }
  });

  $(document).on('click', '.surface-result__calculate', function () {
    calcPricing();
  });

  $(document).on('click', '.surface-result__apply', function (e) {
    $('.surface-popup__close').trigger('click');
    $('.variant-picker__option-values input').each(function () {
      var swatchVal = $(this).val();
      if ($('.surface-variant__selector').val().indexOf(swatchVal) >= 0) {
        $(this).prop('checked', true);
         $(this).parents('.variant-picker').trigger('click');
        e.target.name = 'option'
        $(this).parents('.variant-picker').get(0)._onOptionChanged(e);
      }
    });
    $('.quantity-selector__input').val($('.surface-result__packs').text()).trigger('change');
    $('.product-info__quantity-selector .shopify-product-form .button .money').text($('.surface-result__price').text());
  });

  $(document).on('click', '.surface-unit__item', function () {
    if (!$(this).hasClass('surface-unit__item--active')) {
      if ($('.surface-unit__item--in').hasClass('surface-unit__item--active')) {
        $('.surface-unit__item--in').removeClass('surface-unit__item--active');
        $('.surface-unit__item--cm').addClass('surface-unit__item--active');
        $('.surface-input__ft span').text('m');
        $('.surface-input__in span').text('cm');
        $('.surface-result__row--area .surface-result__text__ft').html('m<sup>2</sup>');
        $('.surface-result__row--area .surface-result__text__in').html('cm<sup>2</sup>');
        $('.surface-result__row--area .surface-result__area--in').hide();
        $('.surface-result__row--area .surface-result__text__in').hide();

        var length_ft = parseFloat($('.surface-row__input--length .surface-input__ft input').val());
        var length_in = parseFloat($('.surface-row__input--length .surface-input__in input').val());
        var width_ft = parseFloat($('.surface-row__input--width .surface-input__ft input').val());
        var width_in = parseFloat($('.surface-row__input--width .surface-input__in input').val());

        var length_m = (length_ft / 3.281).toFixed(2);
        var length_cm = (length_in * 2.54).toFixed(2);
        var width_m = (width_ft / 3.281).toFixed(2);
        var width_cm = (width_in * 2.54).toFixed(2);

        /*
        $('.surface-row__input--length .surface-input__ft input').val(length_m);
        $('.surface-row__input--length .surface-input__in input').val(length_cm);
        $('.surface-row__input--width .surface-input__ft input').val(width_m);
        $('.surface-row__input--width .surface-input__in input').val(width_cm);
        */
        $('.surface-row__input--length .surface-input__ft input').val(0);
        $('.surface-row__input--length .surface-input__in input').val(0);
        $('.surface-row__input--width .surface-input__ft input').val(0);
        $('.surface-row__input--width .surface-input__in input').val(0);

        calcPricing();
      }
      else {
        $('.surface-unit__item--in').addClass('surface-unit__item--active');
        $('.surface-unit__item--cm').removeClass('surface-unit__item--active');
        $('.surface-input__ft span').text('ft');
        $('.surface-input__in span').text('in');
        $('.surface-result__row--area .surface-result__text__ft').html('ft<sup>2</sup>');
        $('.surface-result__row--area .surface-result__text__in').html('in<sup>2</sup>');
        $('.surface-result__row--area .surface-result__area--in').show();
        $('.surface-result__row--area .surface-result__text__in').show();
        
        var length_m = parseFloat($('.surface-row__input--length .surface-input__ft input').val());
        var length_cm = parseFloat($('.surface-row__input--length .surface-input__in input').val());
        var width_m = parseFloat($('.surface-row__input--width .surface-input__ft input').val());
        var width_cm = parseFloat($('.surface-row__input--width .surface-input__in input').val());

        var length_ft = (length_m * 3.281).toFixed(2);
        var length_in = (length_cm / 2.54).toFixed(2);
        var width_ft = (width_m * 3.281).toFixed(2);
        var width_in = (width_cm / 2.54).toFixed(2);

        /*
        $('.surface-row__input--length .surface-input__ft input').val(length_ft);
        $('.surface-row__input--length .surface-input__in input').val(length_in);
        $('.surface-row__input--width .surface-input__ft input').val(width_ft);
        $('.surface-row__input--width .surface-input__in input').val(width_in);
        */
        $('.surface-row__input--length .surface-input__ft input').val(0);
        $('.surface-row__input--length .surface-input__in input').val(0);
        $('.surface-row__input--width .surface-input__ft input').val(0);
        $('.surface-row__input--width .surface-input__in input').val(0);

        calcPricing();
      }
    }
  });

  /* Pattern popup */
  $(document).on('click', '.pattern-popup__overlay', function () {
    $('.pattern-popup').removeClass('pattern-popup--active');
    $('body').removeClass('lock-scroll');
  });

  $(document).on('click', '.pattern-popup__close', function () {
    $('.pattern-popup').removeClass('pattern-popup--active');
    $('body').removeClass('lock-scroll');
  });

  $(document).on('click', '.choose-pattern', function () {
    $('.pattern-popup').addClass('pattern-popup--active');
    $('body').addClass('lock-scroll');
  });

  $(document).on('click', '.pattern-item', function () {
    var maxCount = $('.pattern-selected__item').length;
    var activeCount = $('.pattern-item--active').length;
    if ($(this).hasClass('pattern-item--active')) {
      var patternName = $(this).find('.pattern-item__name').text();
      $('.pattern-selected__item[data-pattern="' + patternName + '"] .pattern-selected__remove').trigger('click');
      $(this).removeClass('pattern-item--active');
      $('.pattern-popup__apply').addClass('pattern-popup__apply--disabled');
    }
    else {
      if (activeCount == maxCount) {
        alert("You've already selected all patterns. Please remove one if you want to choose another pattern.");
      }
      else {
        var patternName = $(this).find('.pattern-item__name').text();
        $('.pattern-selected__item').each(function () {
          if (!$(this).hasClass('pattern-selected__item--active')) {
            $(this).find('.selected-item__name').text(patternName);
            $(this).addClass('pattern-selected__item--active');
            $(this).attr('data-pattern', patternName);
            return false;
          }
        });
        $(this).addClass('pattern-item--active');
        if (activeCount == maxCount - 1) {
          $('.pattern-popup__apply').removeClass('pattern-popup__apply--disabled');
        }
      }
    }
  });

  $(document).on('click', '.pattern-selected__remove', function () {
    var patternName = $(this).parent().find('.selected-item__name').text();
    $(this).parent().removeClass('pattern-selected__item--active');
    $(this).parent().find('.selected-item__name').text('None');
    $(this).parent().attr('data-pattern', '');
    $('.pattern-item[data-pattern="' + patternName + '"]').removeClass('pattern-item--active');
  });

  $(document).on('click', '.pattern-popup__apply', function () {
    if (!$(this).hasClass('pattern-popup__apply--disabled')) {
      var selected_patterns = '';
      $('.pattern-selected__item').each(function () {
        var num = $(this).find('.selected-item__num').text();
        var name = $(this).find('.selected-item__name').text();
        $('.pattern-' + num).val(name);
        if (selected_patterns == '') {
          selected_patterns = name;
        }
        else {
          selected_patterns = selected_patterns + ', ' + name;
        }
      });
      $('.choose-pattern span').text(selected_patterns);
      $('.choosed-patterns').val(selected_patterns);
      if (selected_patterns == 'None, None, None') {
        $('.add-to-cart-cover button').addClass('cta-select-pattern');
        $('.choose-pattern span').text('Choose Patterns');
      }
      else {
        $('.add-to-cart-cover button').removeClass('cta-select-pattern');
      }
      $('.pattern-popup__close').trigger('click');
    }
  });

  /* Mini cart qty action */
  $(document).on('click', '.mini-cart-qty .decrease_button', function() {
    var miniCartQty = $(this).next('.quantity-input'); 
    var currentVal = parseInt(miniCartQty.val());
    miniCartQty.focus();

    if ( currentVal > 1 ) {
      miniCartQty.val(--currentVal);
  
      var event = new CustomEvent("change", {
        bubbles: true,
        detail: {},
      });
      miniCartQty[0].dispatchEvent(event);
    }
  });

  $(document).on('click', '.mini-cart-qty .increase_button', function() {
    var miniCartQty = $(this).prev('.quantity-input'); 
    var currentVal = parseInt(miniCartQty.val());
    miniCartQty.focus();
    miniCartQty.val(++currentVal);

    var event = new CustomEvent("change", {
      bubbles: true,
      detail: {},
    });
    miniCartQty[0].dispatchEvent(event);
  });

  $(document).on('click', '.variant-tooltip', function () {
    if(this.dataset.tab == "none") {
      return; 
    } else if(this.dataset.tab == "size-guide"){
      $('.tabs-header__item:nth-child(3)').trigger('click');
    } else {
      $('.tabs-header__item:nth-child(2)').trigger('click');
    }
    $([document.documentElement, document.body]).animate({
      scrollTop: $('.pdp-tabs__header').offset().top - 200
    }, 500);
  });

  $(document).on('click', '.tabs-header__item', function () {
    let index = $(this).attr('data-index');
    if (!$(this).hasClass('tabs-header__item--active')) {
      $('.tabs-header__item--active').removeClass('tabs-header__item--active');
      $('.tabs-content__item--active').removeClass('tabs-content__item--active');
      $(this).addClass('tabs-header__item--active');
      $(`.tabs-content__item[data-index="${index}"]`).addClass('tabs-content__item--active');
    }
  });
});